import styled from 'styled-components'

export const StepTimeline = styled.ol`
	margin: 42px 0 32px;
	padding: 0;
`
